export { default as CardDetails } from "./cardDetails";
